import React, { useCallback, useState } from 'react'
import { Box, Grid, Accordion, AccordionSummary, AccordionDetails, Theme, Button, useMediaQuery } from '@mui/material'
import { makeStyles } from '@mui/styles'
import Countdown, { CountdownRenderProps } from 'react-countdown'
import moment from 'moment/moment'
import { useDispatch } from 'react-redux'
import * as ls from 'local-storage'
import { useNavigate } from 'react-router-dom'
import { getCheckList, showCheckList, startCheckList } from '../../../api'
import { propsAction } from '../../../store/props'
import { modalsAction } from '../../../store/modals'
import { N1Checklists } from '../../../types/default-types'
import { useReduxSelector } from '../../../hooks'

const Renderer: React.FC<CountdownRenderProps> = ({ hours, minutes }) => {
  return (
    <>
      <span>{hours}&nbsp;ч.&nbsp;</span>&nbsp;
      <span>{minutes}&nbsp;мин.&nbsp;</span>
    </>
  )
}

export const Timer: React.FC<{ timeEnd: number }> = ({ timeEnd = 0 }) => {
  return <Countdown date={timeEnd} renderer={(props) => <Renderer {...props} />} />
}

const Icon: React.FC<{ className: any; img: any }> = ({ className, img = [] }): JSX.Element => {
  return <img src={img.dropdown} alt="" className={className.icon} />
}

export const CheckLists: React.FC<{
  img: any
  data: any
  className: any
  expanded: boolean
  onExpand: () => void
  openCheckList: () => void
}> = ({ data = [], openCheckList = () => {}, className, img = [], expanded, onExpand = () => {} }): JSX.Element => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const mdDown = useMediaQuery(({ breakpoints: { down } }: Theme) => down(960))
  const smDown = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))

  const { data: constants } = useReduxSelector((state) => state.constants)
  const { NOW = 0 } = constants || {}

  const [disabledBtn, setDisabledBtn] = useState<boolean>(false)

  const loadCheckLists = useCallback((index: number, status: string) => {
    if (status === 'NEW') {
      let checklist_all = {
        loaded: true,
        employee: undefined,
        checklist: undefined,
      }
      setDisabledBtn(true)
      openCheckList()
      dispatch(propsAction.setProps({ checklist_all }))

      getCheckList({ requestId: data[index].id })
        .then((res) => {
          if (res.status === 1) {
            checklist_all = {
              loaded: false,
              employee: { ...data[index], stage: 1 },
              checklist: { ...res.data.checklist },
            }
            dispatch(propsAction.setProps({ checklist_all }))
            ls.set('checklist', '?checklist')
            setDisabledBtn(false)
          } else {
            dispatch(
              modalsAction.alert({
                message: { error: [`${res.message}`] },
                onClose: () => {
                  setDisabledBtn(false)
                  navigate('../lk')
                },
              })
            )
          }
        })
        .catch(() => {
          dispatch(
            modalsAction.alert({
              message: { error: ['Сервер временно недоступен. Пожалуйста, попробуйте позже'] },
              onClose: () => {
                setDisabledBtn(false)
                navigate('../lk')
              },
            })
          )
        })
    } else if (status === 'ACTIVE') {
      setDisabledBtn(true)
      openCheckList()
      let checklist_all = {
        loaded: true,
        employee: undefined,
        checklist: undefined,
      }
      dispatch(propsAction.setProps({ checklist_all }))

      startCheckList({ requestId: data[index].id })
        .then((res) => {
          if (res.status === 1) {
            checklist_all = {
              loaded: false,
              employee: { ...data[index], stage: 1 },
              checklist: { ...res.data.checklist },
            }
            dispatch(propsAction.setProps({ checklist_all }))
            ls.set('checklist', '?checklist')
            setDisabledBtn(false)
          } else {
            dispatch(
              modalsAction.alert({
                message: res.message,
                onClose: () => {
                  setDisabledBtn(false)
                  navigate('../lk')
                },
              })
            )
          }
        })
        .catch(() => {
          dispatch(
            modalsAction.alert({
              message: { error: ['Сервер временно недоступен. Пожалуйста, попробуйте позже'] },
              onClose: () => {
                setDisabledBtn(false)
                navigate('../lk')
              },
            })
          )
        })
    } else if (status === 'FINISH') {
      setDisabledBtn(true)
      openCheckList()
      let checklist_all = {
        loaded: true,
        employee: undefined,
        checklist: undefined,
      }
      dispatch(propsAction.setProps({ checklist_all }))

      showCheckList({ checklistId: data[index].checklist.id })
        .then((res) => {
          if (res.status === 1) {
            checklist_all = {
              loaded: false,
              employee: { ...data[index], stage: 1 },
              checklist: { ...res.data.checklist },
            }
            dispatch(propsAction.setProps({ checklist_all }))
            ls.set('checklist', '?checklist')
            setDisabledBtn(false)
          } else {
            dispatch(
              modalsAction.alert({
                message: { error: [`${res.message}`] },
                onClose: () => {
                  setDisabledBtn(false)
                  navigate('../lk')
                },
              })
            )
          }
        })
        .catch(() => {
          dispatch(
            modalsAction.alert({
              message: { error: ['Сервер временно недоступен. Пожалуйста, попробуйте позже'] },
              onClose: () => {
                setDisabledBtn(false)
                navigate('../lk')
              },
            })
          )
        })
    }
  }, [])

  return (
    <>
      <Box className={classes.checkLists}>
        <Accordion square={false} id="checkLists" expanded={expanded} onChange={onExpand}>
          <AccordionSummary expandIcon={<Icon className={className} img={img} />}>
            Чек-листы участников
          </AccordionSummary>
          <AccordionDetails>
            <Box className={className.contentAccordionDetails}>
              {data.map((item: N1Checklists, index: number) => {
                return (
                  <Box key={index} mt={1} className={classes.checkListsItem}>
                    <Grid
                      container
                      wrap={smDown ? 'wrap' : 'nowrap'}
                      justifyContent={smDown ? 'flex-start' : 'space-between'}
                      alignItems="center"
                      spacing={1}
                    >
                      <Grid item xs={12} sm={6} md={5}>
                        <Box className={classes.employeesName}>
                          {item.command.users.length > 1 ? (
                            <>Команда «{item.command.name}»</>
                          ) : (
                            <>
                              {item.command.users[0].lastName} {item.command.users[0].firstName}{' '}
                              {item.command.users[0].middleName}
                            </>
                          )}
                        </Box>
                        <Box className={classes.employeesNomination}>«{item.nomination.name}»</Box>
                      </Grid>
                      <Grid item xs="auto">
                        <Button
                          color="secondary"
                          variant="contained"
                          className={classes.btn}
                          disabled={disabledBtn || item.status === 'REJECT'}
                          onClick={() => {
                            loadCheckLists(index, item.checklist?.status || 'NEW')
                          }}
                        >
                          Чек-лист
                        </Button>
                      </Grid>
                      <Grid item xs="auto">
                        <Box className={classes.checkListsTime}>
                          {item.checklist?.status === 'ACTIVE' &&
                            item.checklist?.endDatetime &&
                            moment(NOW).isBefore(moment(item.checklist?.endDatetime).valueOf()) && (
                              <Timer timeEnd={moment(item.checklist.endDatetime).valueOf()} />
                            )}
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                )
              })}
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  )
}

const useStyles = makeStyles(({ font, breakpoints: { down }, palette }: Theme) => ({
  checkLists: {},
  checkListsItem: {
    marginBottom: 15,
  },
  employeesName: {
    fontSize: 16,
    fontWeight: 500,
    marginBottom: 3,
    [down('md')]: {
      fontSize: 15,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  employeesNomination: {
    fontSize: 16,
    fontWeight: 500,
    color: '#6C6C6C',
    [down('md')]: {
      fontSize: 15,
    },
    [down('sm')]: {
      fontSize: 14,
      marginBottom: 2,
    },
  },
  checkListsTime: {
    fontSize: 17,
    fontWeight: 600,
    color: '#6C6C6C',
    width: 120,
    textAlign: 'center',
    [down('md')]: {
      fontSize: 16,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  btn: {
    fontSize: '16px!important',
    padding: '10px 35px!important',
    minHeight: '30px!important',
    minWidth: '100px!important',
    [down('md')]: {
      fontSize: '15px!important',
      padding: '10px 25px!important',
      minHeight: '30px!important',
    },
    [down('sm')]: {
      fontSize: '12px!important',
      padding: '10px 25px!important',
      minHeight: '25px!important',
      minWidth: '10px!important',
    },
  },
}))
